import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorInput from "../ui/ErrorInput";

export const InputFileMultiple = (props) => {
  const { id, label, files, setFiles, requerido = true, placeholder = "Agregar archivos", formik } = props;

  const remover = (idx) => {
    setFiles((files) => files.filter((e, indx) => indx !== idx));
  };

  return (
    <div className="inputFileMultiple">
      <div>
        <label htmlFor={id}>
          {label} {requerido && "*"}
        </label>
        {formik.errors[id] !== undefined && formik.touched[id] !== undefined && <ErrorInput touched={formik.touched[id]} error={formik.errors[id]} />}
      </div>
      <div
        onClick={() => {
          // if (files.length === 0) {
          document.getElementById(id).click();
          // }
        }}
        className="cursor-pointer d-flex form-control d-flex justify-content-center align-items-center py-3"
      >
        {files.length === 0 ? (
          <p className="m-0">{placeholder}</p>
        ) : (
          <div className="inputFileMultiple-container">
            {files.map((el, idx) => {
              return (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  key={idx}
                  className="badge rounded-pill bg-primary d-flex align-items-center py-1 pe-1 position-relative"
                  style={{ fontWeight: 400, fontSize: "13px" }}
                >
                  {files[idx].name}
                  <FontAwesomeIcon
                    className="ms-2 align-self-center hoverEx"
                    size="xl"
                    icon={faCircleXmark}
                    onClick={() => {
                      remover(idx);
                    }}
                  />
                </span>
              );
            })}
          </div>
        )}
        <input
          type="file"
          name={id}
          id={id}
          hidden
          multiple
          onChange={(e) => {
            setFiles([...files, ...Array.from(e.target.files)]);
          }}
        />
      </div>
    </div>
  );
};
